<template>
    <div id="site-wrapper">

        <header class="site-header"
                :class="{
                    'is--extended': isHeaderExtended,
                    'is--active': isHeaderActive
                }"
                role="banner">
            <slot name="header"></slot>
        </header>

        <main class="main-container flex-grow-1" role="main">
            <div class="main-container-wrapper">
                <slot name="main"></slot>
            </div>
        </main>

    </div>
</template>

<script>
    export default {
        name: 'Layout',
        props: {
            isHeaderExtended: {
                type: Boolean,
                default: false
            },
            isHeaderActive: {
                type: Boolean,
                default: false
            }
        }
    }
</script>